import axios from "./api.config"
import api from "@/utils/index.js"

// 获取栏目列表
export function getchannels(siteId) {
    console.log(" getchannels api",`${api}/api/v1/channels/${siteId}`)
    return axios({
        url: `${api}/api/v1/channels/${siteId}`,
        method: 'get',
        params:{}
    })
}

// 获取内容列表
export function getContents(data) {
    return axios({
        url: `${api}/api/v1/contents`,
        method: 'post',
        data
    })
}

// 获取内容
export function getContent(params) {
    return axios({
        url: `${api}/api/v1/stl/content`,
        method: 'get',
        params
    })
}

// 获取素材
export function getMaterials(queryString) {
    return axios({
        url: `${api}/api/v1/stl/sqlContents/${queryString}`,
        method: 'get',
        params:{}
    })
}

